import {BaseApiRequestParams} from "./base-api-request-params";
import {BaseModel} from "../base-model";

export class BaseDomainParams extends BaseModel {
  requestParams: BaseApiRequestParams;
  deltaCallbackId: String;
  deltaCallback: Function;
  isFullDeltaResponse: Boolean;

  constructor(requestParams: BaseApiRequestParams, fetchParams = {}, deltaCallbackId: String, deltaCallback: Function, isFullDeltaResponse: Boolean, ...rest) {
    super();

    this.requestParams = requestParams;
    this.deltaCallbackId = deltaCallbackId;
    this.deltaCallback = deltaCallback;
    this.isFullDeltaResponse = isFullDeltaResponse;

    Object.assign(this,rest);
    Object.assign(this,fetchParams);
  }
}